<template>
  <div>
    <v-dialog scrollable max-width="1200px" v-model="model" persistent>
      <material-card :title="title" :color="$vuetify.theme.themes.light.success" icon="add" v-if="item">
        <v-card-text>
          <v-form v-model="valid">
            <v-container>
              <v-row justify-center>
                <!-- <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <no-autocomplete-textfield
                    :label="$t('headers.memberdependants.id')"
                    v-model="item.id"
                    :rules="[$rules.required]"
                    class="required"
                    disabled
                  ></no-autocomplete-textfield>
                </div> -->
                <!-- <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <no-autocomplete-textfield
                    :label="$t('headers.redmine.project')"
                    v-model="item.project.name"
                    :rules="[$rules.required]"
                    class="required"
                    disabled
                  ></no-autocomplete-textfield>
                </div> -->
                <!-- <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <v-select
                    v-model="item.tracker"
                    :label="$t('headers.redmine.tracker')"
                    :rules="[$rules.required]"
                    class="required"
                    item-value="id"
                    item-text="name"
                    :items="trackers"
                    return-object
                  ></v-select>
                </div> -->
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <v-select
                    v-model="itemCategory"
                    :label="$t('components.membernotesform.category')"
                    :rules="[$rules.required]"
                    class="required"
                    item-value="value"
                    item-text="label"
                    :items="categories"
                    return-object
                  ></v-select>
                </div>
                <!-- <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <v-select
                    v-model="itemSource"
                    :label="$t('components.portal.demo_benefit_cards.source')"
                    :rules="[$rules.required]"
                    class="required"
                    item-value="value"
                    item-text="label"
                    :items="sources"
                    return-object
                  ></v-select>
                </div> -->
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <no-autocomplete-textfield
                    :label="$t('components.emaildialog.subject')"
                    v-model="item.subject"
                    :rules="[$rules.required]"
                    class="required"
                  ></no-autocomplete-textfield>
                </div>
              </v-row>
              <v-row justify-center>
                <div class="col-12 col-xs-12">
                  <quill-input
                    :value.sync="item.description"
                    :clearable="true"
                    :label="$t('globals.description')"
                  />
                </div>
              </v-row>
              <v-row justify-center>
                <div class="col-12 col-xs-12" v-if="item.id">
                  <quill-input
                    v-model="item.notes"
                    :clearable="true"
                    :label="$t('headers.claim_submissions.comments')"
                  />
                </div>
              </v-row>
              <v-row justify-center>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <v-select
                    v-model="item.status"
                    :label="$t('globals.status')"
                    :rules="[$rules.required]"
                    class="required"
                    item-value="id"
                    item-text="name"
                    :items="statuses"
                    return-object
                  ></v-select>
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <no-autocomplete-textfield
                    :label="
                      $t('globals.priority')
                    "
                    v-model="item.priority.name"
                    :rules="[$rules.required]"
                    class="required"
                    disabled
                  ></no-autocomplete-textfield>
                </div>
                <!-- <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <no-autocomplete-textfield
                    :label="$t('headers.redmine.author')"
                    v-model="item.author.name"
                    :rules="[$rules.required]"
                    class="required"
                    disabled
                  ></no-autocomplete-textfield>
                </div> -->
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <v-select
                    v-model="item.assigned_to"
                    :label="$t('components.new_claim.assigned_to')"
                    :rules="[$rules.required]"
                    class="required"
                    item-value="id"
                    item-text="name"
                    :items="users"
                    return-object
                  ></v-select>
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <no-autocomplete-textfield
                    v-model="item.done_ratio"
                    :label="$t('headers.redmine.done_ratio')"
                    :rules="[$rules.decimal]"
                    prefix="%"
                  ></no-autocomplete-textfield>
                </div>
              </v-row>
              <v-row justify-center>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <pbas-date-picker
                    :label="$t('globals.start_date')"
                    :value="item.start_date"
                    @update-date="item.start_date = $event"
                  ></pbas-date-picker>
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <pbas-date-picker
                    :label="$t('headers.download_centre.due_date')"
                    :value="item.due_date"
                    @update-date="item.due_date = $event"
                  ></pbas-date-picker>
                </div>

                <!-- <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <v-checkbox
                    v-model="item.is_private"
                    :label="$t('headers.redmine.is_private')"
                  ></v-checkbox>
                </div> -->
                <!-- <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <no-autocomplete-textfield
                    v-model="item.estimated_hours"
                    :label="$t('headers.redmine.estimated_hours')"
                    :rules="[$rules.decimal]"
                  ></no-autocomplete-textfield>
                </div> -->
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <no-autocomplete-textfield
                    v-model="item.total_estimated_hours"
                    :label="$t('headers.redmine.total_estimated_hours')"
                    :rules="[$rules.decimal]"
                  ></no-autocomplete-textfield>
                </div>
                <!-- <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <no-autocomplete-textfield
                    v-model="item.spent_hours"
                    :label="$t('headers.redmine.spent_hours')"
                    :rules="[$rules.decimal]"
                  ></no-autocomplete-textfield>
                </div> -->
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <no-autocomplete-textfield
                    v-model="item.total_spent_hours"
                    :label="$t('headers.redmine.total_spent_hours')"
                    :rules="[$rules.decimal]"
                  ></no-autocomplete-textfield>
                </div>
                <!-- <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <pbas-date-picker
                    :label="$t('headers.member_files.created_on')"
                    :value="item.created_on"
                    disabled
                  ></pbas-date-picker>
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <pbas-date-picker
                    :label="$t('headers.redmine.updated_on')"
                    :value="item.updated_on"
                    disabled
                  ></pbas-date-picker>
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <pbas-date-picker
                    :label="$t('headers.redmine.closed_on')"
                    :value="item.closed_on"
                    disabled
                  ></pbas-date-picker>
                </div> -->
              </v-row>
              <v-row justify-center>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <v-file-input
                    small-chips
                    show-size
                    :label="$t('components.portal.image_picker.upload_file')"
                    ref="file"
                    v-on:change="handleFileChange"
                    v-model="file"
                  />
                </div>
                <template v-if="uploads && uploads.length > 0">
                  {{ $t("components.redmine.uploads") }}
                  <div
                    class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
                    v-for="file in uploads"
                    :key="file.upload.token"
                  >
                    {{ file.upload.filename }}
                  </div>
                </template>
              </v-row>
              <v-row justify-center>
                <template
                  v-if="item.attachments && item.attachments.length > 0"
                >
                  {{ $t("views.downloadcenter.files") }}
                  <div
                    class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
                    v-for="file in item.attachments"
                    :key="file.id"
                  >
                    <a :href="file.content_url">{{ file.filename }}</a>
                  </div>
                </template>
              </v-row>
              <v-row justify-center>
                <template v-if="item.journals && item.journals.length > 0">
                  {{ $t("headers.claim_submissions.comments") }}
                  <div
                    class="col-12 col-xs-12"
                    v-for="journal in item.journals"
                    :key="journal.id"
                  >
                    {{ $t("components.redmine.user_note_{0}_{1}", [journal.user.name, $helpers.formatDateTime(journal.created_on)]) }}
                    <!-- User {{ journal.user.name }} commented on
                    {{ $helpers.formatDateTime(journal.created_on) }}: -->
                    <br />
                    {{ journal.notes }}
                  </div>
                </template>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="$emit('close')" :loading="saving">
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="save"
            :disabled="!valid"
            :loading="saving"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import ErrorHandler from "@/components/ErrorHandler.vue";
import { mapActions, mapGetters } from "vuex";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield.vue";
import QuillInput from "@/components/Portal/QuillInput.vue";

export default {
  props: [
    "model",
    "item",
    "redmineKey",
    "redmineProject",
    "statuses",
    "trackers",
    "users",
    "categories",
    "sources",
  ],
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    QuillInput,
  },
  data() {
    return {
      error: null,
      successDialog: false,
      valid: false,
      saving: false,
      file: null,
      uploads: [],
      itemCategory: null,
      itemSource: null
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", ["language"]),
    title() {
      if (this.item && this.item.id) {
        return this.$t("components.redmine.edit_issue_{0}", [this.item.id]);
      }
      return this.$t("components.redmine.add_issue");
    },
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          this.loadData();
        }
      },
    },
  },
  mounted() {},
  methods: {
    ...mapActions("redmine", ["newIssue", "updateIssue", "uploadFile"]),
    handleFileChange(file) {
      console.log(file);
      if (!file) {
        this.file = null;
        return;
      }
      if (file.length == 0) {
        return;
      }
      this.file = file;
      this.submitFile();
    },
    async submitFile() {
      this.saving = true;
      const fr = new FileReader();
      let self = this;
      fr.onload = async function (e) {
        const blob = e.target.result;
        try {
          // let cType = this.file.type;//this.getContentType(this.file);
          // if (cType !== null) {

          const res = (
            await self.uploadFile({
              key: self.redmineKey,
              file: self.file,
              blob: blob,
              // contentType: cType,
            })
          ).data;
          self.uploads.push({
            upload: {
              token: res.upload.token,
              filename: self.file.name,
              content_type: self.file.type, //cType,
            },
          });
          // } else {
          //   this.error = {
          //     customMessage: "Non allowed file type",
          //   };
          // }
          // self.$refs.file.value = null;
          self.file = null;
        } catch (error) {
          self.error = error;
        } finally {
          self.saving = false;
        }
      };

      fr.onerror = function (error) {
        this.error = error;
        this.saving = false;
      };
      fr.readAsArrayBuffer(this.file);
    },
    getContentType(file) {
      let extension = file.name.split(".");
      extension = extension[extension.length - 1];
      switch (extension) {
        case "aac":
          return "audio/aac";
        case "abw":
          return "application/x-abiword";
        case "arc":
          return "application/x-freearc";
        case "avif":
          return "image/avif";
        case "avi":
          return "video/x-msvideo";
        case "azw":
          return "application/vnd.amazon.ebook";
        case "bin":
          return "application/octet-stream";
        case "bmp":
          return "image/bmp";
        case "bz":
          return "application/x-bzip";
        case "bz2":
          return "application/x-bzip2";
        case "cda":
          return "application/x-cdf";
        case "csh":
          return "application/x-csh";
        case "css":
          return "text/css";
        case "csv":
          return "text/csv";
        case "doc":
          return "application/msword";
        case "docx":
          return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        case "eot":
          return "application/vnd.ms-fontobject";
        case "epub":
          return "application/epub+zip";
        case "gz":
          return "application/gzip";
        case "gif":
          return "image/gif";
        case "htm":
          return "text/html";
        case "html":
          return "text/html";
        case "ico":
          return "image/vnd.microsoft.icon";
        case "ics":
          return "text/calendar";
        case "jar":
          return "application/java-archive";
        case "jpeg":
          return "image/jpeg";
        case "jpg":
          return "image/jpeg";
        case "js":
          return "text/javascript";
        case "json":
          return "application/json";
        case "jsonld":
          return "application/ld+json";
        case "mid":
          return "audio/midi";
        case "midi":
          return "audio/midi";
        case "mjs":
          return "text/javascript";
        case "mp3":
          return "audio/mpeg";
        case "mp4":
          return "video/mp4";
        case "mpeg":
          return "video/mpeg";
        case "mpkg":
          return "application/vnd.apple.installer+xml";
        case "odp":
          return "application/vnd.oasis.opendocument.presentation";
        case "ods":
          return "application/vnd.oasis.opendocument.spreadsheet";
        case "odt":
          return "application/vnd.oasis.opendocument.text";
        case "oga":
          return "audio/ogg";
        case "ogv":
          return "video/ogg";
        case "ogx":
          return "application/ogg";
        case "opus":
          return "audio/opus";
        case "otf":
          return "font/otf";
        case "png":
          return "image/png";
        case "pdf":
          return "application/pdf";
        case "php":
          return "application/x-httpd-php";
        case "ppt":
          return "application/vnd.ms-powerpoint";
        case "pptx":
          return "application/vnd.openxmlformats-officedocument.presentationml.presentation";
        case "rar":
          return "application/vnd.rar";
        case "rtf":
          return "application/rtf";
        case "sh":
          return "application/x-sh";
        case "svg":
          return "image/svg+xml";
        case "tar":
          return "application/x-tar";
        case "tif":
          return "image/tiff";
        case "tiff":
          return "image/tiff";
        case "ts":
          return "video/mp2t";
        case "ttf":
          return "font/ttf";
        case "txt":
          return "text/plain";
        case "vsd":
          return "application/vnd.visio";
        case "wav":
          return "audio/wav";
        case "weba":
          return "audio/webm";
        case "webm":
          return "video/webm";
        case "webp":
          return "image/webp";
        case "woff":
          return "font/woff";
        case "woff2":
          return "font/woff2";
        case "xhtml":
          return "application/xhtml+xml";
        case "xls":
          return "application/vnd.ms-excel";
        case "xlsx":
          return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        case "xml":
          return "application/xml";
        case "xul":
          return "application/vnd.mozilla.xul+xml";
        case "zip":
          return "application/zip";
        case "3gp":
          return "video/3gpp";
        case "3g2":
          return "video/3gpp2";
        case "7z":
          return "application/x-7z-compressed";
        default:
          return null;
      }
    },
    loadData() {
      this.uploads = [];
      const category = this.item.custom_fields.filter(o=>o.id===14);
      if (category.length > 0) {
        this.itemCategory = {
          label: category[0].name,
          value: category[0].value
        }
      }
      const source = this.item.custom_fields.filter(o=>o.id===15);
      if (source.length > 0) {
        this.itemSource = {
          label: source[0].name,
          value: source[0].value
        }
      }
    },
    save() {
      let item = JSON.parse(JSON.stringify(this.item));
      item.project_id = item.project.id;
      delete item.project;
      // item.tracker_id = item.tracker.id;
      // delete item.tracker;
      item.status_id = item.status.id;
      delete item.status;
      item.priority_id = item.priority.id;
      delete item.priority;
      // item.category_id = item.priority.id;
      // item.fixed_version_id  = item.priority.id;
      item.assigned_to_id = item.assigned_to.id;
      delete item.assigned_to;

      delete item.author;

      if (item.start_date) {
        item.start_date = item.start_date.split("T")[0];
      }
      if (item.due_date) {
        item.due_date = item.due_date.split("T")[0];
      }
      if (this.uploads.length > 0) {
        item.uploads = this.uploads;
      }

      if (this.itemCategory) {
        const categoryField = item.custom_fields.filter((o) => o.id === 14);
        if (categoryField.length > 0) {
          const index = item.custom_fields.indexOf(categoryField[0]);
          item.custom_fields[index] = {
            attr: {
              id: 14,
            },
            custom_field: {
              value: this.itemCategory.value,
            },
          };
        } else {
          item.custom_fields.push({
            attr: {
              id: 14,
            },
            custom_field: {
              value: this.itemCategory.value,
            },
          });
        }
      }

      if (this.itemSource) {
        const sourceField = item.custom_fields.filter((o) => o.id === 15);
        if (sourceField.length > 0) {
          const index = item.custom_fields.indexOf(sourceField[0]);
          item.custom_fields[index] = {
            attr: {
              id: 15,
            },
            custom_field: {
              value: this.itemSource.value,
            },
          };
        } else {
          item.custom_fields.push({
            attr: {
              id: 15,
            },
            custom_field: {
              value: this.itemSource.value,
            },
          });
        }
      }

      if (item.id) {
        return this.update(item);
      }
      return this.add(item);
    },
    async add(item) {
      try {
        this.saving = true;
        await this.newIssue({
          key: this.redmineKey,
          payload: item,
        });
        this.$emit("success", this.$t("globals.success"));
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    async update(item) {
      try {
        this.saving = true;
        await this.updateIssue({
          key: this.redmineKey,
          id: item.id,
          payload: item,
        });
        this.$emit("success", this.$t("globals.success"));
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style></style>
